import __vue_normalize__ from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './SelectControl.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.handlerClickOutside),expression:"handlerClickOutside"}],staticClass:"b24-select-control",class:_vm.classList},[_c('button',{ref:"button",staticClass:"b24-select-control__button",attrs:{"id":_vm.nativeId,"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){$event.preventDefault();return _vm.handlerClickButton($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.handlerClickButton($event)}}},[_c('span',{staticClass:"b24-select-control__text-button",class:{'_placeholder': !_vm.currentOption}},[_vm._t("trigger-button",[_vm._v("\n        "+_vm._s(_vm.currentLabel)+"\n      ")])],2),_vm._v(" "),(_vm.$slots.appendTrigger || _vm.showAppendTrigger)?_c('span',{staticClass:"b24-select-control__slot _before"},[_vm._t("append-trigger",[_c('arrow-icon',{staticClass:"b24-select-control__arrow",attrs:{"width":24,"heigth":24}})])],2):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"css":false,"duration":150},on:{"before-leave":_vm.handlerHideSelect}},[(_vm.isOpen)?_c(_vm.tagNameOptionsList,{ref:"result",tag:"component",staticClass:"b24-select-control__result",style:(("max-height: " + _vm.maxHeightOptionsList + "px"))},[_vm._t("options",_vm._l((_vm.items),function(item){return _c('li',{key:item[_vm.valuePath],staticClass:"b24-select-control__item"},[_c('element-item',{ref:"resultItem",refInFor:true,staticClass:"b24-select-control__result-element",class:{'_active': item[_vm.valuePath] === _vm.value},attrs:{"tag":"button","size":_vm.sizeOption,"platform":_vm.platform,"is-container":true},on:{"click":function($event){return _vm.handlerClickItem($event, item)}}},[_vm._v("\n            "+_vm._s(item[_vm.labelPath])+"\n          ")])],1)}))],2):_vm._e()],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
